(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3965],{

/***/ 16837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ UploadsAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24196);



var uploadImageToUGCBucket = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/images", "img", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        "".concat("https://db2ui4bhd59ll.cloudfront.net").concat(response.img_url)
                    ];
            }
        });
    });
    return function uploadImageToUGCBucket(file) {
        return _ref.apply(this, arguments);
    };
}();
var uploadImageToCMSBucket = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/cms-images", "img", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        "".concat("https://d2qpirhrfplx04.cloudfront.net").concat(response.img_url)
                    ];
            }
        });
    });
    return function uploadImageToCMSBucket(file) {
        return _ref.apply(this, arguments);
    };
}();
var uploadImageToCoursesBucket = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/courses-images", "img", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.img_url.replace("/learning_paths/", "")
                    ];
            }
        });
    });
    return function uploadImageToCoursesBucket(file) {
        return _ref.apply(this, arguments);
    };
}();
var uploadProfileImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/profile-image", "img", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        "".concat("https://d3erjy8u3ir82s.cloudfront.net").concat(response.img_url)
                    ];
            }
        });
    });
    return function uploadProfileImage(file) {
        return _ref.apply(this, arguments);
    };
}();
var uploadUserNoteBook = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/user-submission-notebook", "ipynb", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.notebook_url
                    ];
            }
        });
    });
    return function uploadUserNoteBook(file) {
        return _ref.apply(this, arguments);
    };
}();
var UploadsAPI = {
    uploadImageToUGCBucket: uploadImageToUGCBucket,
    uploadImageToCMSBucket: uploadImageToCMSBucket,
    uploadProfileImage: uploadProfileImage,
    uploadImageToCoursesBucket: uploadImageToCoursesBucket,
    uploadUserNoteBook: uploadUserNoteBook
};


/***/ }),

/***/ 75484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ CommentList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/comments.ts
var api_comments = __webpack_require__(25764);
// EXTERNAL MODULE: ./src/api/tracking.ts
var tracking = __webpack_require__(5123);
// EXTERNAL MODULE: ./src/components/system/button.tsx
var system_button = __webpack_require__(4642);
// EXTERNAL MODULE: ./src/components/system/select.tsx
var system_select = __webpack_require__(11205);
// EXTERNAL MODULE: ./src/components/system/sticky.tsx
var sticky = __webpack_require__(12074);
// EXTERNAL MODULE: ./src/hooks/confirmation.tsx
var confirmation = __webpack_require__(37710);
// EXTERNAL MODULE: ./src/hooks/is_visible.tsx
var is_visible = __webpack_require__(15538);
// EXTERNAL MODULE: ./src/hooks/local_storage_state.tsx
var local_storage_state = __webpack_require__(87639);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/types/comments.ts
var CommentListOrdering;
(function(CommentListOrdering) {
    CommentListOrdering["Trending"] = "Trending";
    CommentListOrdering["Rating"] = "Rating";
    CommentListOrdering["Recent"] = "Recent";
})(CommentListOrdering || (CommentListOrdering = {}));
var DeletedCommentBody = "Deleted";

// EXTERNAL MODULE: ./src/users/index.tsx + 4 modules
var users = __webpack_require__(95575);
// EXTERNAL MODULE: ./src/utils/index.tsx
var utils = __webpack_require__(44868);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
var _array_with_holes = __webpack_require__(39474);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
var _non_iterable_rest = __webpack_require__(53128);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs





function _toArray(arr) {
  return (0,_array_with_holes/* default */.Z)(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || (0,_non_iterable_rest/* default */.Z)();
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/utils/comment_list.tsx





var applyCommentListConfig = function(comments, config) {
    return removeDeleted(comments).sort(function(c1, c2) {
        if (c1.new_comment) {
            return -1;
        }
        if (c2.new_comment) {
            return 1;
        }
        if (c1.top_comment) {
            return -1;
        }
        if (c2.top_comment) {
            return 1;
        }
        if (config.ordering === CommentListOrdering.Rating) {
            return c2.upvotes - c1.upvotes;
        }
        if (config.ordering === CommentListOrdering.Recent) {
            return c1.created_at <= c2.created_at ? 1 : -1;
        }
        if (config.ordering === CommentListOrdering.Trending) {
            return c1.trending_score <= c2.trending_score ? 1 : -1;
        }
    });
};
var defaultCommentListConfig = {
    ordering: CommentListOrdering.Trending
};
var orderingOptions = [
    {
        value: CommentListOrdering.Trending,
        label: "Trending"
    },
    {
        value: CommentListOrdering.Rating,
        label: "Top rated"
    },
    {
        value: CommentListOrdering.Recent,
        label: "Recently commented"
    }, 
];
// TODO: Should this be filtered out in the backend?
var removeDeleted = function(comments) {
    return comments.filter(function(comment) {
        return comment.body !== DeletedCommentBody;
    }).map(function(comment) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
            children: removeDeleted(comment.children)
        });
    });
};
// Helper function to add a comment anywhere in the tree (path is an array of ids).
var addNested = function(comments, path, newComment) {
    if (path.length === 0) return (0,_to_consumable_array/* default */.Z)(comments).concat([
        newComment
    ]);
    var _path = _toArray(path), id = _path[0], remainingPath = _path.slice(1);
    return comments.map(function(comment) {
        if (comment.id !== id) return comment;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
            children: addNested(comment.children, remainingPath, newComment)
        });
    });
};
// Helper function to replace a comment anywhere in the tree (path is an array of ids).
var replaceNested = function(comments, path, newComment) {
    var _path = _toArray(path), id = _path[0], remainingPath = _path.slice(1);
    return comments.map(function(comment) {
        if (comment.id !== id) return comment;
        return remainingPath.length === 0 ? newComment : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
            children: replaceNested(comment.children, remainingPath, newComment)
        });
    });
};

// EXTERNAL MODULE: ./src/components/comments/comment.tsx
var comments_comment = __webpack_require__(99694);
// EXTERNAL MODULE: ./src/components/system/profile_image.tsx
var profile_image = __webpack_require__(89825);
// EXTERNAL MODULE: ./src/components/system/text_container.tsx
var text_container = __webpack_require__(70865);
// EXTERNAL MODULE: ./src/icons/index.tsx + 55 modules
var icons = __webpack_require__(42381);
// EXTERNAL MODULE: ./src/components/comments/comment.module.css
var comment_module = __webpack_require__(8022);
var comment_module_default = /*#__PURE__*/__webpack_require__.n(comment_module);
;// CONCATENATED MODULE: ./src/components/comments/commentBluredPlaceholder.tsx







var MAX_REPLIES_SHOWN_ON_LOAD = 4;
var CommentBluredPlaceholder = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (comment_module_default()).blurredBox,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,utils/* classNames */.AK)([
                    (comment_module_default()).comment,
                    (comment_module_default()).topComment
                ]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (comment_module_default()).author,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_image/* ProfileImage */.m, {
                                displayName: "I"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Ichimoku"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (comment_module_default()).topCommentIcon,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* StarIcon */.r7, {
                                        color: "orange"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Top comment"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_container/* TextContainer */.l, {
                        children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit<br> sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.<br><br>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.<br><br> Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,utils/* classNames */.AK)([
                    (comment_module_default()).comment
                ]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (comment_module_default()).author,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_image/* ProfileImage */.m, {
                                displayName: "F"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Fibonacci"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_container/* TextContainer */.l, {
                        children: "Sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et <br><br>quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,utils/* classNames */.AK)([
                    (comment_module_default()).comment
                ]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (comment_module_default()).author,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_image/* ProfileImage */.m, {
                                displayName: "I"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Ichimoku"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_container/* TextContainer */.l, {
                        children: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium \uD83D\uDE00"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,utils/* classNames */.AK)([
                    (comment_module_default()).comment
                ]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (comment_module_default()).author,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_image/* ProfileImage */.m, {
                                displayName: "F"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Fibonacci"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_container/* TextContainer */.l, {
                        children: "Sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et <br><br>quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/comments/comment_editor.tsx
var comment_editor = __webpack_require__(81403);
// EXTERNAL MODULE: ./src/components/comments/comment_list.module.css
var comment_list_module = __webpack_require__(13423);
var comment_list_module_default = /*#__PURE__*/__webpack_require__.n(comment_list_module);
;// CONCATENATED MODULE: ./src/components/comments/comment_list.tsx





















var CommentList = function(param) {
    var initialComments = param.comments, contentType = param.contentType, contentIdentifier = param.contentIdentifier, newCommentPlaceholder = param.newCommentPlaceholder, _upsellBarrier = param.upsellBarrier, upsellBarrier = _upsellBarrier === void 0 ? false : _upsellBarrier, onAddComment = param.onAddComment;
    var loginRequired = (0,users/* useUpsell */.$n)().loginRequired;
    var user = (0,users/* useAuth */.aC)().user;
    var ref = (0,react.useState)(initialComments), comments = ref[0], setComments = ref[1];
    var ref1 = (0,react.useState)(defaultCommentListConfig), config = ref1[0], setConfig = ref1[1];
    var ref2 = (0,react.useRef)(null);
    var isVisible = (0,is_visible/* useIsVisible */.O)(ref2);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,local_storage_state/* useLocalStorageState */.R)("comment-".concat(contentType, "-").concat(contentIdentifier), ""), 2), cachedValue = ref3[0], setCachedValue = ref3[1];
    var setShouldWarn = (0,confirmation/* useConfirmation */.p)(false, "You haven't submitted your comment, are you sure you want to leave the page?").setShouldWarn;
    (0,react.useEffect)(function() {
        if (isVisible) tracking/* TrackingAPI.commentSection */.A.commentSection({
            action: "view",
            content_type: contentType,
            content_identifier: contentIdentifier
        });
    }, [
        isVisible
    ]);
    var visibleComments = (0,react.useMemo)(function() {
        if (initialComments.length !== 0 || !upsellBarrier) {
            return applyCommentListConfig(comments, config);
        }
        return [];
    }, [
        comments,
        config
    ]);
    (0,react.useEffect)(function() {
        setComments(initialComments);
    }, [
        initialComments
    ]);
    var handleCreate = function(path, newComment) {
        newComment.new_comment = true;
        setComments(addNested(comments, path, newComment));
        if (onAddComment) onAddComment();
    };
    var handleChange = function(path, updatedComment) {
        setComments(replaceNested(comments, path, updatedComment));
    };
    var handleDelete = function(path, deletedComment) {
        setComments(replaceNested(comments, path, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, deletedComment), {
            body: DeletedCommentBody
        })));
    };
    var allowToWriteComment = loginRequired({
        sourceObject: {
            contentType: contentType,
            uuid: contentIdentifier
        },
        cta: "question.comment"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (comment_list_module_default()).container,
        children: [
            user.loggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(comment_editor/* CommentEditor */.S, {
                submitLabel: "Submit comment",
                placeholder: newCommentPlaceholder,
                initialValue: cachedValue,
                allowClick: allowToWriteComment,
                onChange: function(value) {
                    setShouldWarn(value !== "");
                    setCachedValue(value);
                },
                onSubmit: function(value) {
                    return api_comments/* CommentsAPI.createComment */.c.createComment(value, contentType, contentIdentifier);
                },
                onSuccess: function(comment) {
                    handleCreate([], comment);
                    tracking/* TrackingAPI.commentSection */.A.commentSection({
                        action: "submit",
                        content_type: contentType,
                        content_identifier: contentIdentifier,
                        extra_data: {
                            value: comment.body_text,
                            comment_type: "new"
                        }
                    });
                }
            }),
            !upsellBarrier ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: ref2,
                children: [
                    visibleComments.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (comment_list_module_default()).empty,
                        children: "There are no comments yet. Start the conversation by leaving a comment."
                    }),
                    visibleComments.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,utils/* classNames */.AK)([
                            (comment_list_module_default()).toolbar,
                            (comment_list_module_default()).hasBorder
                        ]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(system_select/* Select */.P, {
                            size: "sm",
                            placeholder: "Sort by",
                            options: orderingOptions,
                            value: config.ordering,
                            onChange: function(ordering) {
                                return setConfig((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                                    ordering: ordering
                                }));
                            }
                        })
                    }),
                    visibleComments.map(function(comment) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(comments_comment/* Comment */.s, {
                            comment: comment,
                            onChange: handleChange,
                            onDelete: handleDelete,
                            onCreate: handleCreate
                        }, comment.id);
                    }),
                    visibleComments.length > 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (comment_list_module_default()).toolbar,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                            type: "outline",
                            size: "sm",
                            onClick: function() {
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth"
                                });
                            },
                            children: "Back to top"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky/* Sticky */.L, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (comment_list_module_default()).upsellContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(users/* Upsell */.QH, {
                                    sourceObject: {
                                        contentType: contentType,
                                        uuid: contentIdentifier
                                    },
                                    cta: "question.comment"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentBluredPlaceholder, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 37710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useConfirmation; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


/**
 * from this comment
 * https://github.com/vercel/next.js/issues/2476#issuecomment-926127255
 */ var throwFakeErrorToFoolNextRouter = function() {
    throw "Abort route change. Please ignore this error.";
};
var useConfirmation = function(shouldWarnInit) {
    var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Are you sure that you want to leave?", onConfirm = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
        return;
    }, onCancel = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {
        return;
    };
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(shouldWarnInit), shouldWarn = ref1[0], setShouldWarn = ref1[1];
    var lastHistoryState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)((ref = __webpack_require__.g.history) === null || ref === void 0 ? void 0 : ref.state);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var storeLastHistoryState = function() {
            lastHistoryState.current = history.state;
        };
        router.events.on("routeChangeComplete", storeLastHistoryState);
        return function() {
            router.events.off("routeChangeComplete", storeLastHistoryState);
        };
    }, [
        router
    ]);
    var revertTheChangeRouterJustMade = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var state = lastHistoryState.current;
        if (state !== null && history.state !== null && state.idx !== history.state.idx) {
            history.go(lastHistoryState.current.idx < history.state.idx ? -1 : 1);
        }
    }, []);
    var killRouterEvent = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        router.events.emit("routeChangeError");
        revertTheChangeRouterJustMade();
        throwFakeErrorToFoolNextRouter();
    }, [
        revertTheChangeRouterJustMade,
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var isWarned = false;
        var routeChangeStart = function(url) {
            if (router.asPath !== url && shouldWarn && !isWarned) {
                isWarned = true;
                if (window.confirm(message)) {
                    router.push(url);
                    if (onConfirm) onConfirm();
                    return;
                } else {
                    if (onCancel) onCancel();
                }
                isWarned = false;
                killRouterEvent();
            }
        };
        var beforeUnload = function(e) {
            if (shouldWarn && !isWarned) {
                var event = e !== null && e !== void 0 ? e : window.event;
                event.returnValue = message;
                return message;
            }
            return null;
        };
        router.events.on("routeChangeStart", routeChangeStart);
        window.addEventListener("beforeunload", beforeUnload);
        return function() {
            router.events.off("routeChangeStart", routeChangeStart);
            window.removeEventListener("beforeunload", beforeUnload);
        };
    }, [
        message,
        shouldWarn,
        killRouterEvent,
        router
    ]);
    return {
        setShouldWarn: setShouldWarn
    };
};


/***/ }),

/***/ 15538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useIsVisible; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


// use this hook to determine if something is currently visible on screen
var useIsVisible = function(ref) {
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        observer.current = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            return setIsVisible(entry.isIntersecting);
        });
        if (ref && ref.current) observer.current.observe(ref.current);
        return function() {
            observer.current.disconnect();
        };
    }, []);
    return isVisible;
};


/***/ }),

/***/ 13423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"comment_list_container__Zffp1","toolbar":"comment_list_toolbar__268AE","hasBorder":"comment_list_hasBorder__ovlL5","spoiler":"comment_list_spoiler__L5huK","upsellContainer":"comment_list_upsellContainer__hZJyz"};

/***/ })

}]);